const UNKNOWN_DEVICE_CATEGORY = 'Unknown'

const getUserDeviceCategory = () => {
  if (!navigator.userAgent) {
    return undefined
  }
  let deviceCategory = UNKNOWN_DEVICE_CATEGORY
  const ua: Record<string, RegExp> = {
    'Generic Linux': /Linux/i,
    Android: /Android/i,
    BlackBerry: /BlackBerry/i,
    Bluebird: /EF500/i,
    'Chrome OS': /CrOS/i,
    Datalogic: /DL-AXIS/i,
    Honeywell: /CT50/i,
    iPad: /iPad/i,
    iPhone: /iPhone/i,
    iPod: /iPod/i,
    macOS: /Macintosh/i,
    Windows: /IEMobile|Windows/i,
    Zebra: /TC70|TC55/i,
  }
  Object.keys(ua).forEach(v => navigator.userAgent.match(ua[v]) && (deviceCategory = v))
  return deviceCategory
}

export enum DEVICES {
  'iPhone' = 'iPhone',
}

export default getUserDeviceCategory
